import { computed, action } from 'mobx';
import { ViewController } from 'elc-service';
import { IProductSizePicker, IProductSizePickerOptions } from '../interfaces/IProductSizePicker';
import { SIZE_PICKER_TYPE } from '../constants/SizePickerTypes';
import { Size } from '../domain/entities/Size';

export class ProductSizePickerViewController extends ViewController {
    private _sizes: Size[];
    private options?: IProductSizePickerOptions;
    private _taxLabel?: string;

    public static formatDropdownPrice(hidePricePerUnit: boolean, size: Size): string {
        const priceFormatted = size?.parentSku?.priceObject?.priceFormatted as string;

        return hidePricePerUnit
            ? `${priceFormatted} ${size?.parentSku?.formattedPrice}`
            : priceFormatted;
    }

    public static formatSizeLabel(
        hidePricePerUnit: boolean,
        size: Size,
        taxLabel: string = ''
    ): string {
        const priceFormatted = size?.parentSku?.priceObject?.priceFormatted as string;
        const dropdownSize = size.value;
        const prefixLabel = taxLabel ? `${taxLabel} ` : '';

        return hidePricePerUnit
            ? `${prefixLabel}${priceFormatted} ${dropdownSize}`
            : `${prefixLabel}${priceFormatted} ${size?.parentSku?.formattedPrice} ${dropdownSize}`;
    }

    @action
    public initialize = (props: IProductSizePicker) => {
        this._sizes = props.sizes || [];
        this.options = props.options;
        const taxLabel = (props.translations && props.translations.taxIncluded) || '';
        this._taxLabel = props.config && props.config.showIncludeTaxLabel ? taxLabel : '';
    };

    @computed
    public get sizes(): Size[] {
        return this._sizes.filter((size: Size) => size.value !== '');
    }

    @computed
    public get taxLabel(): string {
        return this._taxLabel || '';
    }

    @computed
    public get data() {
        const hasMultipleSizes = this.sizes?.length > 1;

        return {
            isDropdownType: this.options?.type === SIZE_PICKER_TYPE.DROPDOWN,
            isChipsThumbnailType: this.options?.type === SIZE_PICKER_TYPE.CHIPS_THUMBNAIL,

            hasMultipleSizes,
            renderThumbnails: hasMultipleSizes || this.options?.showThumbIfSingleSize,
            showPrice: this.options?.showPrice,
            hidePricePerUnit: this.options?.hidePricePerUnit,
            taxLabel: this.taxLabel,
            sliderSettings: {
                dots: false,
                arrows: false,
                infinite: false,
                speed: 500,
                ...this.options?.carousel
            }
        };
    }
}
